var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit_FILL0_wght400_GRAD0_opsz48",
    d: "M7.146,18.2h.84l8.461-8.461-.84-.84L7.146,17.364ZM18.873,8.922,16.428,6.477l.8-.8a1.153,1.153,0,0,1,1.6,0l.84.84a1.153,1.153,0,0,1,0,1.6Zm-.8.8L8.445,19.35H6V16.905l9.626-9.626Zm-2.044-.4-.42-.42.84.84Z",
    transform: "translate(-6 -5.35)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2f8bf138ba45e50c2f69ebdb76255142.svg";
export { ForwardRef as ReactComponent };